module.exports = __webpack_public_path__ + "img/hummer.9dcae526.png";